import Task from '../schema/Task';

export interface GetTasksResponse {
    Value: Task[];
    errorResponse?: Error;
}

export function isGetTaskResponse(response: any): response is GetTasksResponse {
    return response?.Value;
}

export function getErrorFromObject(error: any): Error {
    return error instanceof Error ? error : new Error(JSON.stringify(error));
}
